import { makeStyles } from "@material-ui/core/styles";
import volcanoImg from "../../../images/contents/map/vaa/volcano.png";
import { Box } from "@material-ui/core";
import { LegendBoxList, LegendBoxListItem, LegendBoxListItemText } from "../../legend/LegendBoxComponents";
import { memo } from "react";

const useStyles = makeStyles((theme) => ({
  icon: {
    verticalAlign: "middle"
  },
  iconActual: {
    display: 'inline-block',
    width: '25px',
    height: '9px',
    border: '2px solid #ff0000',
    margin: '0 auto',
    verticalAlign: "middle"
  },
  iconFT6: {
    display: 'inline-block',
    width: '25px',
    height: '9px',
    border: '2px solid #ffc0cb',
    margin: '0 auto',
    verticalAlign: "middle"
  },
  iconFT12: {
    display: 'inline-block',
    width: '25px',
    height: '9px',
    border: '2px solid #ffa500',
    margin: '0 auto',
    verticalAlign: "middle"
  },
  iconFT18: {
    display: 'inline-block',
    width: '25px',
    height: '9px',
    border: '2px solid #1e90ff',
    margin: '0 auto',
    verticalAlign: "middle"
  }
}));

function LegendVaa() {
  const classes = useStyles();
  return (
    <Box>
      <LegendBoxList>
        <LegendBoxListItem>
          <span className={classes.iconFT18} /><LegendBoxListItemText>FT 18H</LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <span className={classes.iconFT12} /><LegendBoxListItemText>FT 12H</LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <span className={classes.iconFT6} /><LegendBoxListItemText>FT 06H</LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <span className={classes.iconActual} /><LegendBoxListItemText>ACTL</LegendBoxListItemText>
        </LegendBoxListItem>
        <LegendBoxListItem>
          <img className={classes.icon} src={volcanoImg} alt="Volcano" /><LegendBoxListItemText>Volcano</LegendBoxListItemText>
        </LegendBoxListItem>
      </LegendBoxList>
    </Box>
  )
}

export default memo(LegendVaa);